import { Slack } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

import { useToast } from '@/hooks/use-toast';
import { generateSlackInstallationLink } from '@/lib/queries/slack';

import slackIcon from '../../routes/_root/integrations/-components/logos/slack.svg?url';
import { Button } from '../ui/button';

interface Props {
  variant: 'main' | 'chat' | 'slack';
}

export const AddToSlackButton = ({ variant }: Props): JSX.Element => {
  const { toast } = useToast();

  const handleInstallSlack = async () => {
    try {
      const installationLink = await generateSlackInstallationLink();
      window.location.href = installationLink;
    } catch (error) {
      toast({
        title: 'global.slack.installationFailed',
      });
      console.error('Error generating Slack installation link:', error);
    }
  };

  if (variant === 'chat') {
    return (
      <Button
        variant="outline"
        className="py-0 px-2 h-8 bg-muted rounded-full"
        type="button"
        onClick={handleInstallSlack}
      >
        <Slack size={24} className="inline" />
        <span className="inline-block min-w-[100px] text-center">
          <FormattedMessage id="configuration.slackApp.button.label" />
        </span>
      </Button>
    );
  }

  if (variant === 'slack') {
    return (
      <Button
        className="w-full px-6 py-4 bg-[#4A154B] hover:bg-[#4A154B]/95 text-white rounded-lg shadow-lg hover:shadow-xl py-8"
        onClick={handleInstallSlack}
        type="button"
      >
        <div className="text-black text-sm text-black/80 bg-white rounded-sm py-2 px-4 border hover:bg-white/95">
          <img
            src={slackIcon}
            alt="Slack Icon"
            className="w-5 h-5 mr-2 inline-block"
          />
          <span className="font-medium">
            <FormattedMessage
              id="gettingStarted.welcomeCard.getStarted.button"
              values={{
                slack: <b className="font-semibold">Slack</b>,
              }}
            />
          </span>
        </div>
      </Button>
    );
  }

  return (
    <Button
      variant="main"
      className="text-white"
      type="button"
      onClick={handleInstallSlack}
    >
      <Slack size={24} className="inline mr-2" />
      <span className="inline-block min-w-[100px] text-center">
        <FormattedMessage id="configuration.slackApp.button.label" />
      </span>
    </Button>
  );
};
